exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hidie-first {\n  visibility: hidden\n}\n@media print {\n.non-printable {\n    display: none\n}\n}\n", ""]);

// exports
